import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { CallbackComponent } from './call-back/call-back.component';
import { AuthService } from 'src/app/services/auth.service';

const routes = [
  {
    path: 'callback',
    component: CallbackComponent
  }
];

@NgModule({
  imports: [
    CommonModule,

    RouterModule.forChild(routes)
  ],
  declarations: [CallbackComponent],
  exports:[
    RouterModule,
    CallbackComponent
  ]
})
export class UsersModule {

  public static forRoot(environment: any): ModuleWithProviders<UsersModule> {

    return {
        ngModule: UsersModule,
        providers: [
            AuthService,
            {
                provide: 'env', 
                useValue: environment
            }
        ]
    };
}

}
